import { BaseModel } from "sjs-base-model";

export default class ResponseEsitoModel extends BaseModel {
    public readonly esito: boolean = false;
    public readonly infoEsito: string = "";

    constructor(data: Partial<ResponseEsitoModel>) {
        super();

        this.update(data);
    }
}
